import { render } from "./PostListItem.vue?vue&type=template&id=18a490d2"
import script from "./PostListItem.vue?vue&type=script&lang=js"
export * from "./PostListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__